<template>
  <div class="Tekshiruv">
    <div
      v-for="(itemP, indexTek) in datas.inspection"
      :key="indexTek"
      class="inspec-loop"
    >

      <div>
        <div>
          <PechatLogo />
        </div>
      </div>

      <div class="BayonotChild">
        <div style="width: 100%;">
            <PechatBemorData 
              :datas="datas"
              :date="itemP.date_doctor"
              :name="itemP.inspection.name"
              :bolim="itemP.category.name"
              :doctor_name="itemP.inspection.User.user_name"
            />
          </div>
      </div>
      <div
        class="vueTextEditorT"
        v-for="(itemCh, indCh) in itemP.registration_inspection_child"
        :key="indCh"
      >
        <div
          v-for="(itemText, indText) in JSON.parse(itemCh.norm)"
          :key="indText"
          class="text-page"
          :style="indText ? 'padding-top: 20px;' : ''"
        >
        <div style="border: 1px solid #000;">
          <ckeditor
            v-if="itemP.table_type"
            :style="indText ? 'height: 1250px;' : 'height: 1040px;' + 'width: 917px;'"
            v-model="itemText[`${itemText.key}`]"
            :editor="editor"
            :config="editorConfig"
          >
          </ckeditor>
          <vue-editor
            v-else
            :style="indText ? 'height: 1250px;' : 'height: 1040px;' + 'width: 917px;'"
            v-model="itemText[`${itemText.key}`]"
            :editor-toolbar="customToolbar"
          />
        </div>
        
        <div>
          <PechatFooter />
        </div>
      
      </div>
      </div>
      <div v-if="itemP.a4_images.length > 0">
        <h2>Rasmlar</h2>
        <div class="pictures">
          <div class="grid-item" v-for="(img, inx) in itemP.a4_images">
            <img
            class="fit-picture"
            :src="BASE_URL + img.image_name"
            />
            <!-- <p style="font-size: 30px;"><b>{{ inx + 1 }} - rasm</b></p> -->
          </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import PechatLogo from "./Components/PechatLogo.vue";
import PechatBemorData from "./Components/PechatBemorData.vue";
import PechatFooter from "./Components/PechatFooter.vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  inject: ["BASE_URL"],
  components: {
    PechatLogo,
    PechatBemorData,
    PechatFooter
  },
  data() {
    return {
      datas: {},
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
          // The configuration of the editor.
      },
      customToolbar: [
        // [],
        // ["bold", "italic", "underline"],
        // [{ list: "ordered" }, { list: "bullet" }],
        // ["image", "code-block"]
      ],
    };
  },
  created() {
    this.datas = JSON.parse(localStorage.getItem("Tekshiruvlar"));
  },
  methods: {
    
  },
  mounted() {
    window.print()
    setTimeout(() => {
      localStorage.removeItem("Tekshiruvlar");
      window.close();
      this.$router.push({ path: "/user" });
    }, 3000);
  }
};
</script>

<style scope lang="scss">
.vueTextEditorT .quillWrapper {
  border: none !important;
}
.vueTextEditorT .quillWrapper #quill-container {
  /* font-size: 18px !important; */
  border: none !important;
}
.vueTextEditorT .ql-toolbar {
  display: none;
}
.ql-editor{
  color: #000;
}
.vueTextEditorT .ql-editor {
    // text-transform: uppercase;
    font-family: 'Times New Roman', Times, serif !important;
    // color: #000;
    p{
        font-size: 20pt;
        line-height: 20pt;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 26pt;
    }
    h2{
        font-size: 24pt !important;
        line-height: 24pt;
    }
    h3{
        font-size: 14pt !important;
        line-height: 14pt;
    }
    h4{
        font-size: 12pt !important;
        line-height: 12pt;
    }
    h5{
        font-size: 10pt !important;
        line-height: 10pt;
    }
    h6{
        font-size: 8pt !important;
        line-height: 8pt;
        // color: red;
        text-transform:  none !important;
    }
}
.ck.ck-editor{
    width: 917px;
}
.ck-editor__editable_inline{
    height: 1000px !important;
}
.ck-editor__editable {
    p{
        font-size: 20pt;
        line-height: 26px;
        margin: 0px !important;
        padding: 0px !important;
        font-family: 'Times New Roman', Times, serif;
    }
    strong {
        font-weight: 700 !important;
    }
    u{
      font-weight: 700 !important;
    }
    h1, h2, h3, h4, h5, h6 {
        // text-transform: uppercase;
        font-family: 'Times New Roman', Times, serif !important;
        // color: #000;
        // font-size: 20px;
        font-weight: 400;
    }
    h1{
        font-size: 26pt !important;
        line-height: 32px;
    }
    h2{
        font-size: 24pt !important;
        line-height: 30px;
    }
    h3{
        font-size: 22pt !important;
        line-height: 28px;
    }
    h4{
        font-size: 18pt !important;
        line-height: 24px;
    }
    h5{
        font-size: 16pt !important;
        line-height: 22px;
    }
    h6{
        font-size: 14pt !important;
        line-height: 20px;
    }
}
.ck-content .table table td{
    padding: 0px 5px !important;
    text-align: center;
    font-size: 11pt;
}
.ck-content .table table th{
    padding: 0px 5px !important;
    text-align: center !important;
    font-size: 11pt;
}
.ck-editor__top {
  display: none !important;
}
.ck.ck-editor__main>.ck-editor__editable{
  border: none !important;
}
.bg-image{
  /* width: 100%; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  border: 1px solid red;
  position: absolute;
  /* background-size: contain; */
  
}
.textEdirorSh{
  // margin-top: 20px;
  /* padding-top: 40px; */
  /* padding: 10px; */
}
.textEdirorShI{
  /* padding-top: 40px; */
  /* padding: 10px; */
}
.Tekshiruv {
  padding: 20px;
  width: 959px;
  margin: 0px auto;
  /* background-image: url(../../../public/dovtor_o_logo.png); */
  /* background-size: cover; */
  /* border: 5px double #000; */
  /* margin: 10px; */
  /* display: flex;
  flex-wrap: wrap; */
}
.BayonotChild {
  display: flex;
  margin-top: 15px;
  /* border: none !important; */
}
.inspec-loop{
  // page-break-after: always;
  page-break-inside: always;
  list-style: none;
  margin: 0px auto;
  padding-top: 20px !important;
}
.inpec-name-style{
  font-size: 20px;
  font-weight: 700;
  color: #000;
  text-align: center;
}
.text-page{
  page-break-inside: avoid;
  list-style: none;
  position: relative;
}

</style>
